import { render } from "./ContainerCustom.vue?vue&type=template&id=5663466e"
const script = {}

import "./ContainerCustom.vue?vue&type=style&index=0&id=5663466e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__